import React from 'react';
import { IconClose } from '@prisjakt/ui/icon/close';
import { StyledTag, TagClose, TagGroup, TagValue } from './styles';

const CLEAR = 'clear';
const DEFAULT = 'default';

export const Tag: React.FC<TabProps> = ({
  value,
  groupName,
  type = DEFAULT,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
}) => {
  const isClear = type === CLEAR;
  return (
    <StyledTag type="button" onClick={onClick} clear={isClear}>
      {groupName && type !== CLEAR && <TagGroup>{groupName}:</TagGroup>}
      <TagValue clear={isClear}>{value}</TagValue>
      {type !== CLEAR && (
        <TagClose>
          <IconClose size={16} color="base0" />
        </TagClose>
      )}
    </StyledTag>
  );
};

interface TabProps {
  value: string;
  groupName?: string;
  type?: typeof DEFAULT | typeof CLEAR;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}
